var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrainingVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8359 19.5078C27.3145 19.7812 27.6562 20.3281 27.6562 20.875C27.6562 21.4902 27.3145 22.0371 26.8359 22.3105L16.9922 28.3262C16.5137 28.5996 15.8301 28.668 15.3516 28.3262C14.8047 28.0527 14.5312 27.5059 14.5312 26.8906V14.8594C14.5312 14.3125 14.8047 13.7656 15.3516 13.4922C15.8301 13.1504 16.5137 13.1504 16.9922 13.4922L26.8359 19.5078ZM16.7188 15.8848V25.9336L24.9219 20.875L16.7188 15.8848ZM2.5 20.875C2.5 11.2363 10.293 3.375 20 3.375C29.6387 3.375 37.5 11.2363 37.5 20.875C37.5 30.582 29.6387 38.375 20 38.375C10.293 38.375 2.5 30.582 2.5 20.875ZM20 36.1875C28.4082 36.1875 35.3125 29.3516 35.3125 20.875C35.3125 12.4668 28.4082 5.5625 20 5.5625C11.5234 5.5625 4.6875 12.4668 4.6875 20.875C4.6875 29.3516 11.5234 36.1875 20 36.1875Z",
    fill: "#8DA5BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrainingVideo);
export default __webpack_public_path__ + "static/media/icon-training-video.cb43a7e3.svg";
export { ForwardRef as ReactComponent };